import FleetManagement from "../../views/clientView/fleet/FleetManagement";

export default function FleetPage() {
  return <FleetManagement />;
}
